import { useQuery } from 'react-query';

//APP
import { api } from '../../api';
import { localConfig } from '../../../Configs/localConfig';
import { errorAlert } from '../../../utils/alert';

//=================================================================================>
// BUSCAR LISTA DE PROPRIEDADES E SEUS TALHÕES
//<=================================================================================

//TYPES
export type Item__EquipeCliente = {
    cod: number | null,
    cod_func: number | null,
    cod_conta: number | null,
    cod_cliente: number | null,
    status: number | null,
    acessa_sistema: number | null,
    cod_perfil_conta: number | null,
    cod_perfil_cliente: number | null,
    cod_perfil_cliente_geral: number | null,
    cod_consultor: number | null,
    acesso_cliente: number | null,
    responsavel_fertilidade: boolean,
    usuario_nome: string | null,
    conta_nome: string | null,
    cliente_nome: string | null,
    email: string | null,
    cliente_logo: string | null,
    conta_logo: string | null,
    conta_logo_url: string | null,
}

//INTERFACE
export interface EquipeCliente {
    itens: Item__EquipeCliente[]
}

export const useGetEquipeCliente = () => {

    let { conta, codCliente } = localConfig();

    const queryKey: any = [`equipe_cliente_${conta}_${codCliente}`];

    const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<EquipeCliente, Error>(queryKey, async () => {
        return api.get(`/equipe?codConta=${conta}&codCliente=${codCliente}`)
            .then((response):any => {
                return response.data
            })
            .catch((error) => {
                errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de membros da equipe!');
            })
        },
        {
            enabled: true,
            refetchOnWindowFocus: false,
            staleTime: 200000
        }
    );

    return { 
        data_equipe_cliente: data?.itens, 
        carregando_equipe_cliente: isFetching, 
        refetch_equipe_cliente: refetch,
        isFetched: isFetchedAfterMount,
        isError: isError
    };
};